module.exports = {
  baseApi: process.env.VUE_APP_BASE_API || 'http://localhost:3000',
  firebaseConfig: {
    apiKey: "AIzaSyCoh6kWzbWZlVuKPRy70aJFiQUjx60mW48",
    authDomain: "clasworld-calendar.firebaseapp.com",
    projectId: "clasworld-calendar",
    storageBucket: "clasworld-calendar.appspot.com",
    messagingSenderId: "869393455650",
    appId: "1:869393455650:web:94ec3e5bcf3d393d22087b"
  },
  firebasePublicVapidKey: 'BGJWr0_RyrzUHSXqQKMNp2EqBapLWwhLbe7xpFTS8jOVcnuKW7o3lkzpaxXF7mEjkNDSSSxWbERTtz7OvG0rYHA',
  firebaseServerKey: 'AAAACSuKWYE:APA91bHmzNAuxHWP5pBRLOA3PdZVgd-_x6HN7krbzx56SinzXn6Bjjh1_1tad5QpUeOh2YVZUUxsW13xoIDnoutLd4dFqurF4WqTJkEBh5yExw3MNdsGbPVle6Z34fehlS_xEM4QQUuL'
}
